import { useAppState } from 'state/store'

export function useRTL() {
  return useAppState(state => state.i18n.locale === 'ar-SA')
}
